module.exports = __webpack_public_path__ + "img/loginHead@2x.1a3f3030.png";